import AppLoader from './AppLoader.connect';

export default AppLoader;
